/*
 * Ryan O'Dowd
 * 2025-05-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const ForceUpgrade = (__props: ForceUpgradeProps) => {
  return null;
};

class ForceUpgradeProps {
  mostRecentVersion: string; // @TODO: should this be a prop? feel like this component should fetch it from redux
};

export default ForceUpgrade;
